<ng-container *transloco="let t">
  <ng-container *ngIf="product">
    <div class="stack stack-vertical stack-16">
      <div class="product-attribute stack stack-horizontal stack-center">
        <raf-text variant="body-medium" color="grey-text">{{t('PRODUCT.CODE')}}:</raf-text>
        <raf-text variant="body-medium" color="primary-text">{{product.code}}</raf-text>
      </div>

      <div class="product-attribute stack stack-horizontal stack-center">
        <raf-text variant="body-medium" color="grey-text">{{t('PRODUCT.VENDOR_CODE')}}:</raf-text>
        <raf-text variant="body-medium" color="primary-text">{{product.vendorCode}}</raf-text>
      </div>

      <div class="product-attribute stack stack-horizontal stack-center">
        <raf-text variant="body-medium" color="grey-text">{{t('PRODUCT.EAN')}}:</raf-text>
        <raf-text variant="body-medium" color="primary-text">{{product.ean}}</raf-text>
      </div>

      <div class="product-attribute stack stack-horizontal stack-4 stack-center">
        <raf-text variant="body-medium" color="grey-text">{{t('PRODUCT.BRAND')}}:</raf-text>
        <raf-text variant="body-medium" color="primary-text">{{product.brand}}</raf-text>

        <!-- todo jak budeme hledat v katalogu dle vyrobce? -->
        <!--<a class="mat-button-extra-small" color="secondary"  mat-button routerLink="/xxx-c50">
          {{product.brand}}
        </a>-->

      </div>

      <div class="product-attribute product-category-line stack stack-horizontal stack-4">

        <raf-text class="product-category-label" variant="body-medium" color="grey-text">{{t('PRODUCT.CATEGORIES')}}:</raf-text>

        <div class="product-category-value stack stack-4">
          <a *ngFor="let category of product.categories" class="mat-button-extra-small" color="secondary" mat-button [routerLink]="category.url">{{category.name}}</a>
        </div>

      </div>

      <div class="product-attribute stack stack-horizontal stack-center">
        <raf-text variant="body-medium" color="grey-text">{{t('PRODUCT.GROUP')}}:</raf-text>
        <raf-text variant="body-medium" color="primary-text">{{product.group}}</raf-text>
      </div>

      <div class="product-attribute stack stack-horizontal stack-center">
        <raf-text variant="body-medium" color="grey-text">{{t('PRODUCT.COUNTRY_OF_ORIGIN')}}:</raf-text>
        <raf-text variant="body-medium" color="primary-text">{{product.countryOfOrigin}}</raf-text>
      </div>
    </div>

  </ng-container>
</ng-container>
